import React from 'react';

import {
  CheckBoxOutlineBlank as BaseCheckBoxOutlineBlankIcon,
  CheckBox as BaseCheckBoxIcon,
  IndeterminateCheckBox as BaseIndeterminateCheckBoxIcon,
  KeyboardArrowDown as BaseKeyboardArrowDownIcon,
  KeyboardArrowUp as BaseKeyboardArrowUpIcon
} from '@mui/icons-material';
import {
  Box,
  Checkbox,
  IconButton,
  ListItem,
  ListItemText,
  styled
} from '@mui/material';



const FullWidthListItem = styled(ListItem)({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between'
});

const MainBox = styled(Box)<{indentLevel: number}>(({ indentLevel, theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  marginLeft: theme.spacing(indentLevel * 4)
}));

const CheckBoxOutlineBlankIcon = styled(BaseCheckBoxOutlineBlankIcon)({
  color: '#87ACB9'
});

const CheckBoxIcon = styled(BaseCheckBoxIcon)({
  color: '#87ACB9'
});

const IndeterminateCheckBoxIcon = styled(BaseIndeterminateCheckBoxIcon)({
  color: '#87ACB9'
});

const KeyboardArrowDownIcon = styled(BaseKeyboardArrowDownIcon)({
  color: '#87ACB9'
});

const KeyboardArrowUpIcon = styled(BaseKeyboardArrowUpIcon)({
  color: '#87ACB9'
});



export type ICheckedState = 'unchecked' | 'indeterminate' | 'checked';

export function getCheckedStateByCounts(checkedCounts: number, allCounts: number): ICheckedState {
  if (checkedCounts === 0) {
    return 'unchecked';
  } else if (checkedCounts === allCounts) {
    return 'checked';
  } else {
    return 'indeterminate';
  }
}



interface IProps extends React.HTMLAttributes<HTMLLIElement> {
  label: string;
  indentLevel?: number;
  checkState: ICheckedState;
  isOpen: boolean;

  onCheck?: () => void;
  onOpen?: () => void;
}

export const FC: React.FC<IProps> = props => {
  const defaultProps = (({
    label,
    indentLevel,
    checkState,
    isOpen,
    onCheck,
    onOpen,
    ...remainder
  }) => (remainder))(props);

  return (
    <FullWidthListItem {...defaultProps} onClick={props.onOpen}>
      <MainBox indentLevel={props.indentLevel ?? 0}>
        <ListItemText>{props.label}</ListItemText>

        <IconButton>
          {props.isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
      </MainBox>

      <Checkbox
        icon={<CheckBoxOutlineBlankIcon />}
        indeterminateIcon={<IndeterminateCheckBoxIcon />}
        checkedIcon={<CheckBoxIcon />}
        indeterminate={props.checkState === 'indeterminate'}
        checked={props.checkState === 'checked'}
        onClick={props.onCheck} />
      {props.children}
    </FullWidthListItem>
  );
};
